// ChatMessage.tsx
import React from "react";
import { Avatar, Box, Typography } from "@mui/material";
import TextStep from "./TextStep";
import { Message } from "./chat";

interface ChatMessageProps {
  msg: Message;
  isLastLisMessage: boolean;
  avatarLisUrl?: string;
  onDone?: () => void;
}

const ChatMessage: React.FC<ChatMessageProps> = ({
  msg,
  isLastLisMessage,
  avatarLisUrl,
  onDone,
}) => {
  return (
    <Box
      sx={{
        maxWidth: { xs: "90%", sm: "94%" },
        width: "100%",
        ml: msg.from === "user" ? "auto" : 0,
        mr: msg.from === "user" ? 0 : "auto",
        px: 1,
        display: "flex",
        alignItems: "flex-end",
        flexDirection: msg.from === "user" ? "row-reverse" : "row",
        gap: 1,
      }}
    >
      <Avatar
        src={msg.from === "user" ? "/images/avatar-user.svg" : avatarLisUrl}
        alt={msg.from === "user" ? "Usuário" : "Lis"}
        sx={{
          width: 24,
          height: 24,
        }}
      />
      <Box
        sx={{
          bgcolor: msg.from === "user" ? "#F5FAFE" : "white",
          borderRadius: "12px",
          borderBottomLeftRadius: msg.from === "user" ? "12px" : 0,
          borderBottomRightRadius: msg.from === "user" ? 0 : "12px",
          px: { xs: 1.5, sm: 2 },
          py: { xs: 1, sm: 1.5 },
          position: "relative",
          fontSize: { xs: 14, sm: 16 },
          overflowWrap: "break-word",
          wordBreak: "break-word",
          maxWidth: "100%",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 500,
            fontSize: { xs: 14, sm: 16 },
            lineHeight: "18px",
            letterSpacing: "0.5px",
            color: "#6E7286",
            wordBreak: "break-word",
            overflowWrap: "break-word",
            pl: 0.5,
          }}
        >
          {msg.from === "lis" && typeof msg.text === "string" ? (
            <TextStep text={msg.text} />
          ) : (
            msg.text
          )}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            mt: 0.5,
            textAlign: "right",
            display: "block",
            fontWeight: 500,
            fontSize: "13px",
            lineHeight: "18px",
            letterSpacing: "0px",
            color: "#999EB0",
            fontFamily: "Inter, sans-serif",
          }}
        >
          {msg.time}
        </Typography>
      </Box>
    </Box>
  );
};

export default React.memo(ChatMessage);
